import { translate } from "../../../common/providers";

export function displayTrustLevel(trustLevel) {
	return translate(`norms-center.trust-level.${trustLevel.trim()?.toLowerCase().replaceAll("_", "-")}`);
}
